







































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import moment from 'moment'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { nameMap } from '@/modules/budget/monitoring/reports-constructor/common/nameMap'
import { cloneDeep, max } from "lodash"
import { Classificator } from "../../../common/types/Classificator"
import { ReportEibRow } from "../table-data/ReportEibRow"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { Segmentation } from "../../../common/types/roots/fields"

export interface TableField {
    key: string,
    label: string,
    active: boolean,

    income?: string,
    expense?: string,
}

type RowKey = keyof ReportEibRow

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class ReportEib extends Vue {

    // region Props
    @Prop({
        type: Array,
        required: true,
    })
    public readonly tableData!: ReportEibRow[]

    @Prop({
        type: Date,
        required: true,
        default: new Date(),
    })
    private readonly date!: Date

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly segmentations!: Array<{ value: Segmentation; active: boolean }>

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]
    // endregion

    // region Data
    public indicators: string[] = ['name', 'plan', 'execution', 'remaining', 'completion', 'dayCompletions', 'monthCompletion']
    public indicatorsNameMap: Record<string, string> = { // TODO: replace with $t
        'name': 'Наименование',
        'plan': 'Скорректированный план',
        'execution': 'Кассовое исполнение', 
        'remaining': 'Остаток', 
        'completion': '% исполнения', 
        'dayCompletions': 'Исполнение по дням',
        'monthCompletion': 'На отчетный месяц'
    }
    public subColumnKeys: string[] = []
    public dayNumber = 0
    public classificationColumns: TableField[] = []
    public currentPage = 1
    public rowKeys: RowKey[] = [
        'name',
        'yearPlan',
        'upToMonthPlan',
        'monthPlan',
        'upToMonthExecution',
        'dayExecution',
        'yearRemaining',
        'periodRemining',
        'yearCompletionPercentage',
        'periodCompletionPercentage',
        'dayCompletions',
        'monthCompletion'
    ]
    private monthNameMap: Record<number, string> = {
        1: 'янв',
        2: 'фев',
        3: 'мар',
        4: 'апр',
        5: 'мая',
        6: 'июн',
        7: 'июл',
        8: 'авг',
        9: 'сен',
        10: 'окт',
        11: 'ноя',
        12: 'дек'
    }
    perPage = 30
    tableCollapse = true
    // endregion

    // region Computed
    // endregion

    // region LifeCycle
    private created() {
        this.constructTableFields()
        this.setSubcolumns()
        this.handlePageChange(1)
    }
    // endregion

    // region Methods
    collapse(index: number, collapse: boolean, collapseAll: boolean = false) {
        const el = this.tableData.find(it => it.index === index)
        
        if (!el) {
            return
        }

        if (el.hasChild) {
            for (const child of this.tableData) {
                if (child.parentIndex === index) {
                    child.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(child.index, collapse, collapseAll)
                        child.collapse = collapse
                    }
                }
            }
        }
        el.collapse = collapse
    }

    collapseAll(collapse: boolean) {
        for (const item of this.tableData) {
            if (item.parentIndex === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.index, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public get visibleRows(): number {
        return this.tableData.filter(it => it.visible).length
    }

    public get currentItems(): ReportEibRow[] {
        const startIndex = (this.currentPage - 1) * this.perPage
        const endIndex = startIndex + this.perPage
        return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
    }

    private constructTableFields() {
        const activeSegmentations = cloneDeep(this.segmentations.filter(it => it.active).map(it => it.value))
        const activeIncomes = cloneDeep(this.incomes.filter(it => it.active).map(it => it.key))
        const activeExpenses = cloneDeep(this.expenses.filter(it => it.active).map(it => it.key))

        let currentIncomes = cloneDeep(activeIncomes)
        let currentExpenses = cloneDeep(activeExpenses)

        if (!activeSegmentations.find(key => key === 'KBK')) {
            currentIncomes = []
            currentExpenses = []
        }

        if (activeSegmentations.find(key => key === 'REGION')) {
            if (activeSegmentations[0] === 'REGION') {
                if (activeIncomes.length > 0) {
                    currentIncomes = ['region'].concat(currentIncomes)
                }
                if (activeExpenses.length > 0) {
                    currentExpenses = ['region'].concat(currentExpenses)
                }
            } else {
                if (activeIncomes.length > 0) {
                    currentIncomes.push('region')
                }
                if (activeExpenses.length > 0) {
                    currentExpenses.push('region')
                }
            }
        }
        
        const categoriesSpan: number = max([currentIncomes.length, currentExpenses.length]) ?? 0
        
        currentExpenses = currentExpenses.map(it => {
            if (it === 'spf') {
                return 'espf'
            }
            if (it === 'region') {
                return 'eregion'
            }
            return it
        })

        const classificationColumns: TableField[] = []
        for (let i = 0; i < categoriesSpan; i++) {
            const incomeKey = currentIncomes[i]
            const expenseKey = currentExpenses[i]
            // @ts-ignore
            const incomeLabel = nameMap[incomeKey]
            // @ts-ignore
            const expenseLabel = nameMap[expenseKey]

            const column: TableField = {
                key: `${incomeKey}/${expenseKey}`,
                label: `${incomeLabel??' - '}/${expenseLabel??' - '}`,
                income: incomeKey,
                expense: expenseKey,
                active: true
            }
            classificationColumns.push(column)
        }

        this.classificationColumns = classificationColumns
    }

    private setSubcolumns() {
        const subcols = ['на год', 'на отчетный месяц', 'за отчетный месяц', 'на отчетный месяц', 'на день', 'на год', 'на отчетный период', 'на год', 'на отчетный период']
        const mDate = moment(this.date)
        const currentDay = mDate.date()
        const monthShortName = this.monthNameMap[mDate.month() + 1]
        for (let i = 0; i < currentDay; i++) {
            const dayNumber = (i + 1).toString().padStart(2, '0')
            subcols.push(`${dayNumber}.${monthShortName}`)
        }

        this.dayNumber = currentDay
        this.subColumnKeys = subcols
    }

    public isTotalRow(row: ReportEibRow): boolean {
        return (
            row.region == null
            && row.kat == null
            && row.cls == null
            && row.pcl == null
            && row.spf == null

            && row.eregion == null
            && row.gr == null
            && row.pgr == null
            && row.abp == null
            && row.prg == null
            && row.ppr == null
            && row.espf == null
        )
    }

    public formatNumber = formatDigitsGrouping
    // endregion
}
